import React from 'react'
import style from './style'
import injectSheet from 'react-jss'
import { Range } from 'rc-slider'

function handle(props) {
  const { offset, classes, resolutionDisabled } = props
  return (
    <div>
      <div className={resolutionDisabled ? classes.disabledHandle : classes.handle} style={{ left: `${offset}%` }} />
    </div>
  )
}

class ResolutionRange extends React.Component {
  min = 1
  max = this.props.orderedResolutions.length
  state = {
    left: this.min,
    right: this.max
  }

  updateResolutions = arr => {
    this.setState({ left: arr[0], right: arr[1] })
  }

  filterResolutions = arr => {
    this.props.filterCameras({
      resolutions: {
        lowI: arr[0] - 1,
        highI: arr[1] - 1
      }
    })
  }

  render() {
    const { props: { classes, orderedResolutions, resolutionDisabled }, min, max, filterResolutions, updateResolutions } = this
    return (
      <div className={classes.ResolutionRange}>
        <div>Resolution</div>
        <Range
          min={min}
          max={max}
          defaultValue={[min, max]}
          handle={props => handle({ ...props, classes, resolutionDisabled })}
          onChange={updateResolutions}
          onAfterChange={filterResolutions}
          className={resolutionDisabled ? classes.disabled : ''}
        />
        <div className={classes.display}>
          <div>
            <strong>{orderedResolutions[this.state.left - 1].name}</strong>
          </div>
            to
          <div>
            <strong>{orderedResolutions[this.state.right - 1].name}</strong>
          </div>
        </div>
      </div>
    )
  }
}

export default injectSheet(style)(ResolutionRange)



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/Filter/ResolutionRange/index.js